"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tags = void 0;
var is_nil_1 = require("../../utils/is-nil");
var Tags = function (target) {
    return /** @class */ (function (_super) {
        __extends(Tags, _super);
        function Tags() {
            var constructorArgs = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                constructorArgs[_i] = arguments[_i];
            }
            var _this = _super.apply(this, constructorArgs) || this;
            var createTag = _this.options.get('createTag');
            if (!is_nil_1.isNil(createTag)) {
                _this.createTag = createTag;
            }
            var insertTag = _this.options.get('insertTag');
            if (!is_nil_1.isNil(insertTag)) {
                _this.insertTag = insertTag;
            }
            var tags = _this.options.get('tags');
            if (Array.isArray(tags)) {
                for (var t = 0; t < tags.length; t++) {
                    var tag = tags[t];
                    var item = _this.normalizeItem(tag);
                    var option = _this.option(item);
                    _this.core.element.append(option);
                }
            }
            return _this;
        }
        Tags.prototype.query = function (params, callback) {
            this.removeOldTags();
            if (is_nil_1.isNil(params.term) || !is_nil_1.isNil(params.page)) {
                _super.prototype.query.call(this, params, callback);
                return;
            }
            var wrapper = function (obj, child) {
                var data = obj.results;
                for (var i = 0; i < data.length; i++) {
                    var option = data[i];
                    var checkChildren = (option.children != null &&
                        !wrapper({ results: option.children }, true));
                    var optionText = (option.text || '').toUpperCase();
                    var paramsTerm = (params.term || '').toUpperCase();
                    var checkText = optionText === paramsTerm;
                    if (checkText || checkChildren) {
                        if (child) {
                            return false;
                        }
                        obj.data = data;
                        callback(obj);
                        return;
                    }
                }
                if (child) {
                    return true;
                }
                // TODO: Refactor this
                // const tag = this.createTag(params);
                //
                // if (!isNil(tag))
                // {
                //     const option = this.option(tag);
                //     option.setAttribute('data-select2-tag', 'true');
                //
                //     this.addOptions([option]);
                //
                //     this.insertTag(data, tag);
                // }
                obj.results = data;
                callback(obj);
            };
            _super.prototype.query.call(this, params, wrapper);
        };
        Tags.prototype.createTag = function (params) {
            if (params.term == null) {
                return null;
            }
            var term = params.term.trim();
            if (term === '') {
                return null;
            }
            return { id: term, text: term };
        };
        Tags.prototype.insertTag = function (data, tag) {
            data.unshift(tag);
        };
        Tags.prototype.removeOldTags = function (_) {
            var options = Array.from(this.core.element.querySelectorAll('option[data-select2-tag]'));
            options.forEach(function (option) {
                if (option.selected) {
                    return;
                }
                option.remove();
            });
        };
        return Tags;
    }(target));
};
exports.Tags = Tags;
//# sourceMappingURL=tags.js.map